export enum KeyCookie {
    cmsToken = 'cmsToken',
    selfToken = 'selfToken',
}

export const setCookie = (nameCookie: string, value: string) => {
    // var name = nameCookie + '='
    // var decodedCookie = decodeURIComponent(document.cookie)
    document.cookie = `${nameCookie}=${value} path=/`
}

export const getCookie = (nameCookie: string) => {
    var name = nameCookie + '='
    var decodedCookie = decodeURIComponent(document.cookie)
    var ca = decodedCookie.split(';')
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) === ' ') {
            c = c.substring(1)
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length)
        }
    }
    return ''
}

export const removeCookie = (nameCookie: string) => {
    const cookies = document.cookie.split(';')
    for (var i = 0; i < cookies.length; i++) {
        // var eqPos = cookie.indexOf("=");
        // var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = nameCookie + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;'
    }
}

export const getSelfToken = () => getCookie(KeyCookie.selfToken)
export const getCmsToken = () => getCookie(KeyCookie.cmsToken)

export const removeSelfToken = () => removeCookie(KeyCookie.selfToken)
export const removeCmsToken = () => removeCookie(KeyCookie.cmsToken)

export const setSelfToken = (value: string) => setCookie(KeyCookie.selfToken, value)
export const setCmsToken = (value: string) => setCookie(KeyCookie.cmsToken, value)
